import "./dark.scss";
import { ThemeOptions } from "@material-ui/core";

const dark: ThemeOptions = {
  palette: {
    type: "dark",
    primary: {
      main: "#5ebc45",
      dark: "#5ebc45",
      contrastText: "#ffffff",
    },
    secondary: {
      main: "#ff0000",
      dark: "#ff0000",
      contrastText: "#ffffff",
    },
    text: {
      primary: "#b9b9b9",
    },
  },
};

export default dark;
